import { colors } from "@mui/material";
import { useMemo } from "react";

import { Link } from "components/Link";
import { ProductStockNotificationDeleteButton } from "components/ProductStockNotificationDeleteButton";
import { Column, Table } from "components/Table";
import { useAuthentication } from "hooks/useAuthentication";
import { useLayout } from "hooks/useLayout";
import { StockNotification } from "types/models";
import { isBluecarRole } from "utils/models/user";

const baseColumns: Column<StockNotification>[] = [
  {
    id: "product_id",
    label: "Producto",
    renderer: ({ product }) => (
      <Link
        to={`/products/${product.id}`}
        style={{ color: colors.blue[500], textDecoration: "underline" }}
        noMargin
        external
      >
        {product.name}
      </Link>
    ),
  },
  {
    id: "product",
    label: "Marca (Grupo / Línea)",
    renderer: ({ product }) =>
      `${product.brand_name} (${product.group_name} / ${product.line_name})`,
  },
  {
    id: "id",
    label: "Acciones",
    renderer: (stockNotification) => (
      <ProductStockNotificationDeleteButton
        stockNotification={stockNotification}
      />
    ),
  },
];

const companyColumns: Column<StockNotification>[] = [
  // {
  //   id: "user_id",
  //   label: "Empresa",
  //   renderer: ({ user }) => user.company.id,
  // },
  {
    id: "user",
    label: "Usuario",
    renderer: ({ user }) =>
      user.name && user.email
        ? `${user.name} <${user.email}>`
        : user.name || user.email || "-",
  },
];

export const BackofficeStockNotifications = () => {
  const { BackofficeLayout } = useLayout({
    isPrivate: true,
    title: "Notificaciones de stock",
  });
  const { user } = useAuthentication();

  const columns = useMemo(() => {
    if (user && isBluecarRole(user)) {
      return [...companyColumns, ...baseColumns];
    }
    return baseColumns;
  }, [user]);

  return (
    <BackofficeLayout>
      <Table
        columns={columns}
        queryKey="stock_notifications"
        path="stock_notifications"
      />
    </BackofficeLayout>
  );
};
